import React from 'react'

export default function PrincetonGreenLogo() {
  return (
    <div className="split" data-testid="princetonGreen-org">
    <span className="princetone-link1">princeton</span>
    <span className="princetone-link2">green</span>
    <span className="princetone-link3">.org</span>
  </div>
  )
}
